import { useEffect, useRef, useState } from 'react'

export function useSmoothAnchorScroll(anchorId: string) {
  const [shouldSetId, setShouldSetId] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const hashId = window.location.hash?.replace('#', '')

    // This prevents default browser scrolling by skipping the id on first render
    if (!shouldSetId) setShouldSetId(true)

    if (hashId === anchorId) {
      const timer = setTimeout(() => {
        ref.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }, 500)

      return () => clearTimeout(timer)
    }
  }, [anchorId, shouldSetId])

  return { ref, shouldSetId }
}
